var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".edge-logo-cls-1{fill:#ffffff;}.edge-logo-cls-1,.edge-logo-cls-2{fill-rule:evenodd;}.edge-logo-cls-2{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation_header_L_sticky",
    "data-name": "Navigation/header_L_sticky"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edge_logo_dark",
    "data-name": "edge logo dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "edge-logo-cls-1",
    d: "M41.51,13.26a4.91,4.91,0,0,0-4.83-4,4.82,4.82,0,0,0-4.84,4Zm-9.7,2.63A5.37,5.37,0,0,0,37,20.14,7.29,7.29,0,0,0,42,18l2,2.41a10,10,0,0,1-6.94,3,8.63,8.63,0,0,1-8.62-8.72,8.18,8.18,0,0,1,8.32-8.26c4.77,0,8.36,3.79,8.36,9.54Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "edge-logo-cls-1",
    d: "M60.84,14.84A5.16,5.16,0,1,0,55.68,20a5.17,5.17,0,0,0,5.16-5.13m0-6.51V0H64.1v23H61.31V21a8.16,8.16,0,0,1-5.66,2.34,8.49,8.49,0,0,1,0-17,7.73,7.73,0,0,1,5.16,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "edge-logo-cls-1",
    d: "M79.8,14.84A5.18,5.18,0,1,0,74.64,20,5.2,5.2,0,0,0,79.8,14.84Zm3.26,6.35c0,6.28-3.85,8.71-7.57,8.71a8.25,8.25,0,0,1-4.67-1.41l1.29-2.73a6,6,0,0,0,3.19.95c2.73,0,4.6-1.87,4.6-5.49a7.75,7.75,0,0,1-5.29,2.11,8.49,8.49,0,1,1,0-17A7.85,7.85,0,0,1,80.2,8.66v-2h2.86Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "edge-logo-cls-1",
    d: "M98.33,13.26a4.91,4.91,0,0,0-4.83-4,4.82,4.82,0,0,0-4.84,4Zm-9.7,2.63a5.37,5.37,0,0,0,5.23,4.25A7.29,7.29,0,0,0,98.79,18l2,2.41a10,10,0,0,1-6.94,3,8.63,8.63,0,0,1-8.62-8.72,8.18,8.18,0,0,1,8.32-8.26c4.77,0,8.36,3.79,8.36,9.54Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "edge-logo-cls-2",
    points: "24.63 3.37 17.33 23.44 0.43 23.44 4.22 13 10.88 13 14.38 3.37 24.63 3.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "edge-logo-cls-2",
    points: "12.86 0 9.05 10.46 0 10.46 3.82 0 12.86 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.6ef3b0dceccccb114b78b725ec0a88f7.svg";
export { ForwardRef as ReactComponent };